import type { RouteObject } from 'react-router-dom';
import { RequirePermission } from '../auth/guards';
import { PlanConfigPage } from './PlanConfigPage';
import { PlanFormPage } from './PlanFormPage';

const guard = (element: JSX.Element) => (
  <RequirePermission code="PC232">{element}</RequirePermission>
);

/** Plan Config (PC232) routes, mounted under the app shell. */
export const plansRoutes: RouteObject[] = [
  { path: 'settings/plans', element: guard(<PlanConfigPage />) },
  // `key` gives each form its own state, so "Add Plan" never starts with a plan that was being edited.
  { path: 'settings/plans/new', element: guard(<PlanFormPage key="new" />) },
  { path: 'settings/plans/:id/edit', element: guard(<PlanFormPage key="edit" />) },
];
